(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    var form = root.querySelector('[data-product-form]');
    var idInput = root.querySelector('[data-variant-id]');
    var price = root.querySelector('[data-price]');
    var add = root.querySelector('[data-add]');
    var addLabel = root.querySelector('[data-add-label]');
    var note = root.querySelector('[data-note]');
    var figures = root.querySelectorAll('[data-media-id]');
    var money = function (cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: root.dataset.currency || 'USD' });
    };
    var chosen = function () {
      var picks = [];
      root.querySelectorAll('[data-option-index]:checked').forEach(function (i) { picks[Number(i.dataset.optionIndex) - 1] = i.value; });
      return picks;
    };
    var sync = function () {
      var picks = chosen();
      if (!picks.length) return;
      var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === picks[i]; }); });
      if (!match) {
        add.disabled = true;
        addLabel.textContent = add.dataset.unavailable || 'Unavailable';
        return;
      }
      idInput.value = match.id;
      price.textContent = money(match.price);
      add.disabled = !match.available;
      addLabel.textContent = match.available ? (add.dataset.addText || 'Add to bag') : (add.dataset.soldOut || 'Sold out');
      if (match.featured_media) {
        figures.forEach(function (f) { f.toggleAttribute('data-current', Number(f.dataset.mediaId) === match.featured_media.id); });
      }
      if (history.replaceState) {
        var url = new URL(location.href); url.searchParams.set('variant', match.id); history.replaceState(null, '', url);
      }
    };
    root.querySelectorAll('[data-option-index]').forEach(function (i) { i.addEventListener('change', sync); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      add.disabled = true;
      var body = new FormData(form);
      fetch(form.action + '.js', { method: 'POST', body: body, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; });
          note.hidden = false;
          note.innerHTML = (add.dataset.added || 'In your bag.') + ' <a href="/cart">' + (add.dataset.viewBag || 'View bag') + '</a>';
          add.disabled = false;
        })
        .catch(function (err) {
          note.hidden = false; note.textContent = err.message; add.disabled = false;
        });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
